import { ScrollView } from '@rbilabs/universal-components';

export const Scroller = ScrollView.withConfig({
  paddingTop: {
    base: '$16',
    md: '$20',
  },
});
